import { useEffect } from 'react';
import { getRankChartPrintLayout } from './rankChartPrintLayout';

export const RANK_CHART_PRINT_STYLE_ID = 'rank-chart-print-page-styles';

export const getRankChartPrintStyleText = (layoutId, paperId) => {
  const printLayout = getRankChartPrintLayout(layoutId, paperId);
  return `
  @page {
    size: ${printLayout.pageSize};
    margin: ${printLayout.pageMargin};
  }

  @media print {
    html,
    body,
    #root {
      background: #fff !important;
      height: auto !important;
      margin: 0 !important;
      min-height: 0 !important;
      overflow: visible !important;
    }

    #scroll_wrapper {
      display: block !important;
      height: auto !important;
      overflow: visible !important;
    }

    .rank-chart-print-preview {
      background: #fff;
      min-height: 0;
      padding: 0;
    }

    .rank-chart-print-controls {
      display: none !important;
    }

    .rank-chart-print-sheet {
      box-shadow: none;
      margin: 0;
    }

    .rank-chart-print-sheet--has-following {
      break-after: page;
      page-break-after: always;
    }
  }
`;
};

export const addRankChartPrintStyles = (layoutId, paperId, documentRef = document) => {
  const existingStyle = documentRef.getElementById(RANK_CHART_PRINT_STYLE_ID);
  if (existingStyle) {
    return null;
  }

  const styleElement = documentRef.createElement('style');
  styleElement.id = RANK_CHART_PRINT_STYLE_ID;
  styleElement.textContent = getRankChartPrintStyleText(layoutId, paperId);
  documentRef.head.appendChild(styleElement);
  return styleElement;
};

export const removeRankChartPrintStyles = (styleElement) => {
  if (styleElement && styleElement.parentNode) {
    styleElement.parentNode.removeChild(styleElement);
  }
};

export const useRankChartPrintStyles = (layoutId, paperId) => {
  useEffect(() => {
    const styleElement = addRankChartPrintStyles(layoutId, paperId);
    return () => removeRankChartPrintStyles(styleElement);
  }, [layoutId, paperId]);
};
